export default __webpack_public_path__ + "static/media/apmed.1dfce056.png";